import {AccessArea} from 'Common/permissions/AccessArea';
import {BrowserOrServerId} from 'Browser/BrowserId';


export abstract class Role<Id extends BrowserOrServerId>
{
	constructor(
		readonly name:string,
	)
	{ }

	public abstract topAccess(): AccessArea;

	public abstract canAccessArea(area:AccessArea,siteId:Id):boolean;

	public amManager(_artistId:Id):boolean { return false; }

	public abstract toJson(): any;
}

